import styled from 'styled-components'

export const Subtext = styled.h3`
    color: ${({theme}) => theme.colour.LIGHT_GREY};
    font-size: 20px;
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    position: relative;
    bottom: 10px;
    left: 1px;
    font-weight: 100;
`